import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private toastSubject = new Subject<string>();
  toast$ = this.toastSubject.asObservable();

  // This method will trigger the toast with a message
  showToast(message: string) {
    console.log('mess ',message)
    this.toastSubject.next(message);
  }
}
